export const environment = {
    production: false,
    version: '1.1.0',
    apiEndPoint: process.env.REACT_APP_BASE_URL,
  };